import { Matcher, type MatchResponse } from 'interweave'
import { Link } from 'router-v6'

interface TelMatcherProps {
  'data-test': string
  'data-rawNumber': string
  valid: boolean
}
const ValidDate = /[0-9]{2}[/\-.][0-9]{2}[/\-.][0-9]{4}/
const ValidPhone = /\b[+]?[0-9]{1,3}\s?[(]?[0-9]{1,4}[)]?[-\s.]?[0-9]{2,10}[-\s.]?[0-9]{3,10}\b/

export class TelMatcher extends Matcher<TelMatcherProps> {
  private readonly minimumPhoneNumberLength = 6

  match(string: string): MatchResponse<TelMatcherProps> | null {
    const result = string.match(ValidPhone)

    // Early returns for invalid cases
    if (!result) return null

    const isDate = !!result[0].match(ValidDate)
    if (isDate) return null

    const isLengthValid = result[0].replace(/\D/g, '').length >= this.minimumPhoneNumberLength
    if (!isLengthValid) return null

    // Extract and clean the phone number
    const rawNumber = result[0].replace(/\D/g, '')

    return {
      index: result.index ?? 0,
      length: result[0].length,
      match: result[0],
      'data-test': 'tele-link',
      'data-rawNumber': rawNumber,
      valid: true,
    }
  }

  replaceWith(children: React.ReactNode, props: TelMatcherProps) {
    return (
      <Link
        to={`/conversations/new/call?q=${props['data-rawNumber']}`}
        className="text-primary hover:underline"
        data-testid="link-phone-number"
        {...props}
      >
        {children}
      </Link>
    )
  }

  asTag(): string {
    return 'a'
  }
}

// Create a singleton instance
export const telMatcher = new TelMatcher('tel')
